module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_simple_rec_20.3b8a5448.png";